import { BA_STEPS } from "../../Containers/GettingStartedPage/utils/businessSteps"
import { OB_STEPS } from "../../Containers/GettingStartedPage/utils/onboardingSteps"

export const BA_ROUTE_STEP_MAP = {
  "business-info": BA_STEPS.COMPANY,
  "payment-connect": BA_STEPS.INTEGRATION,
  enrollment: BA_STEPS.ENROLLMENT,
  alerts: BA_STEPS.ALERTS,
  billing: BA_STEPS.ALERTS,
  bin: BA_STEPS.ALERTS,
  "card-info": BA_STEPS.CARD,
  "top-up": BA_STEPS.TOP_UP
}
export const ONBOARDING_ROUTE_STEP_MAP = {
  "business-info": OB_STEPS.COMPANY,
  "payment-connect": OB_STEPS.INTEGRATION,
  enrollment: OB_STEPS.ENROLLMENT,
  alerts: OB_STEPS.ALERTS,
  "card-info": OB_STEPS.CARD,
  "top-up": OB_STEPS.TOP_UP,

  billing: OB_STEPS.ALERTS,
  bin: OB_STEPS.ALERTS
}

export const getOnboardingStepId = (stepKey) => {
  return ONBOARDING_ROUTE_STEP_MAP[stepKey] ?? null
}

const getStepId = (routeStepMap, stepKey) => routeStepMap?.[stepKey] ?? null

export const canAccessStep = ({
  nextStep,
  stepKey,
  routeStepMap,
  finalStep,
  allowedStepsOnFinal = []
}) => {
  const targetStepId = getStepId(routeStepMap, stepKey)

  if (!targetStepId || !nextStep) return false

  if (nextStep === finalStep) {
    return allowedStepsOnFinal.includes(targetStepId)
  }

  return targetStepId <= nextStep
}

export const getOnboardingPathByStepId = (stepId) => {
  const entry = Object.entries(ONBOARDING_ROUTE_STEP_MAP).find(
    ([key, value]) => value === stepId && !["billing", "bin"].includes(key)
  )

  return entry ? `/onboarding/${entry[0]}` : "/onboarding/business-info"
}

export const getBusinessPathByStepId = (stepId) => {
  const entry = Object.entries(BA_ROUTE_STEP_MAP).find(
    ([key, value]) => value === stepId && !["billing", "bin"].includes(key)
  )

  return entry ? `/create-account/${entry[0]}` : "/create-account/business-info"
}
